var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-top": "1px solid #f1f1f1",
      "border-bottom": "1px solid #f1f1f1",
      "margin-top": "20px",
      "padding": "20px"
    }
  }, [(!_vm.nameInput) ? _c('div', [_c('div', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.session.zhanghao.name) + "\n                "), _c('Icon', {
    staticClass: "hover",
    attrs: {
      "type": "ios-create-outline"
    },
    on: {
      "click": function($event) {
        _vm.nameInput = true;
        _vm.form.zhenshixingming = _vm.session.zhanghao.name
      }
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.session.jigou.jituan.name)), (_vm.session.jigou.name != _vm.session.jigou.jituan.name) ? _c('span', [_vm._v(" - " + _vm._s(_vm.session.jigou.name))]) : _vm._e(), _vm._v("（ " + _vm._s(_vm.session.jigou.code) + " ）")])]) : _vm._e(), _vm._v(" "), (_vm.nameInput) ? _c('div', {
    staticStyle: {
      "font-size": "24px",
      "padding": "20px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("修改真实姓名:")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "180px",
      "margin-left": "20px"
    },
    model: {
      value: (_vm.form.zhenshixingming),
      callback: function($$v) {
        _vm.$set(_vm.form, "zhenshixingming", $$v)
      },
      expression: "form.zhenshixingming"
    }
  }), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.nameInput = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nameChanged
    }
  }, [_vm._v("确定")])], 1) : _vm._e()]), _vm._v(" "), (!_vm.phoneInput) ? _c('div', {
    staticClass: "jcsb",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bold"
    }
  }, [_vm._v("手机号")]), _vm._v(" "), _c('div', [_vm._v("已绑定手机号：" + _vm._s(_vm.session.user.phone))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', [(!_vm.session.user.pubopenid) ? _c('Button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toBindWechat
    }
  }, [_vm._v("绑定微信")]) : _c('Button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toBindWechat
    }
  }, [_vm._v("解绑微信")])], 1), _vm._v(" "), _c('Button', {
    on: {
      "click": function($event) {
        _vm.phoneInput = true
      }
    }
  }, [_vm._v("更换手机号")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.phoneInput) ? _c('div', [(_vm.phoneInputStep == 1) ? _c('div', [(_vm.codeSend == false) ? _c('div', {
    staticStyle: {
      "padding": "20px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', [_vm._v("验证原手机号:" + _vm._s(_vm.session.user.phone))]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sendCode(_vm.session.user.phone)
      }
    }
  }, [_vm._v("发送验证码")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.phoneInput = false
      }
    }
  }, [_vm._v("取消")])], 1) : _vm._e(), _vm._v(" "), (_vm.codeSend) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', [_vm._v("请输入原手机号:" + _vm._s(_vm.session.user.phone) + "收到的验证码")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "10px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.form.smscode),
      callback: function($$v) {
        _vm.$set(_vm.form, "smscode", $$v)
      },
      expression: "form.smscode"
    }
  }), _vm._v(" "), (_vm.cd > 0) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "default",
      "disabled": ""
    }
  }, [_vm._v("重新获取（" + _vm._s(_vm.cd) + ")")]) : _vm._e(), _vm._v(" "), (_vm.cd <= 0) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sendCode(_vm.session.user.phone)
      }
    }
  }, [_vm._v("重新获取")]) : _vm._e(), _vm._v(" "), (!_vm.form.smscode) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.phoneInput = false
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.form.smscode) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.checkCode()
      }
    }
  }, [_vm._v("继续")]) : _vm._e()], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.phoneInputStep == 2) ? _c('div', [(!_vm.codeSend) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('span', [_vm._v("请输入新手机号：")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  }), _vm._v(" "), (_vm.cd > 0) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "default",
      "disabled": ""
    }
  }, [_vm._v("获取验证码（" + _vm._s(_vm.cd) + ")")]) : _vm._e(), _vm._v(" "), (_vm.cd <= 0) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sendCode(_vm.form.phone)
      }
    }
  }, [_vm._v("获取验证码")]) : _vm._e(), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.phoneInputStep = 1
      }
    }
  }, [_vm._v("返回")])], 1) : _vm._e(), _vm._v(" "), (_vm.codeSend) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', [_vm._v("请输入新手机号:" + _vm._s(_vm.form.phone) + "收到的验证码")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "10px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.form.smscode),
      callback: function($$v) {
        _vm.$set(_vm.form, "smscode", $$v)
      },
      expression: "form.smscode"
    }
  }), _vm._v(" "), (_vm.cd > 0) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "default",
      "disabled": ""
    }
  }, [_vm._v("重新获取（" + _vm._s(_vm.cd) + ")")]) : _vm._e(), _vm._v(" "), (_vm.cd <= 0) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sendCode(_vm.form.phone)
      }
    }
  }, [_vm._v("重新获取")]) : _vm._e(), _vm._v(" "), (!_vm.form.smscode) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.codeSend = false;
      }
    }
  }, [_vm._v("返回")]) : _vm._e(), _vm._v(" "), (_vm.form.smscode) ? _c('Button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.savePhone
    }
  }, [_vm._v("完成")]) : _vm._e()], 1)]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.zhengshuguanli && _vm.session && _vm.session.zhanghao && (!_vm.session.zhanghao.jituanadmin) && _vm.session.zhanghao.zhengshu) ? _c('div', {
    staticStyle: {
      "padding": "20px",
      "border-top": "1rpx solid #f1f1f1"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bold"
    }
  }, [_vm._v("证书")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "150px"
    },
    attrs: {
      "src": _vm.session.zhanghao.zhengshu.url + '?imageView2/1/w/200/h/300'
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "border-top": "1rpx solid #f1f1f1"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bold"
    }
  }, [_vm._v("角色")]), _vm._v(" "), _vm._l((_vm.session.zhanghao.jueses), function(item, index) {
    return _c('div', {
      key: index
    }, [_vm._v(_vm._s(item.name))])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.session.zhanghao.jigou.type != 'MD') ? _c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bold",
      "padding": "20px 0"
    }
  }, [_vm._v("管辖范围")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px",
      "background-color": "#fafafa",
      "min-width": "200px",
      "border-radius": "4px"
    }
  }, [_c('div', [_vm._v("管辖机构")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "color": "#20bf64",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.keyongguanxiajigous.length))]), _vm._v(" 个机构")])]), _vm._v(" "), (_vm.firstlevel.length) ? _c('div', {
    staticStyle: {
      "max-height": "500px",
      "overflow-y": "scroll"
    }
  }, _vm._l((_vm.firstlevel), function(item, index) {
    return _c('div', {
      staticStyle: {
        "padding": "0 4px",
        "box-sizing": "border-box",
        "position": "relative",
        "margin-top": "8px"
      }
    }, [_c('div', {
      key: index,
      staticClass: "jcsb"
    }, [_c('div', {
      staticClass: "nowrap",
      staticStyle: {
        "width": "160px"
      }
    }, [_vm._v("- " + _vm._s(item.name) + "\n                                ")]), _vm._v(" "), _c('Tag', [_vm._v(_vm._s(item.type))])], 1)])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background-color": "#fafafa",
      "min-width": "200px",
      "border-radius": "4px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("管辖仓库")]), _vm._v(" "), (_vm.session.zhanghao['guanxiacangkumode'] == 'part') ? _c('div', [_c('span', {
    staticStyle: {
      "color": "#20bf64",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.session.zhanghao.guanxiacangkus.length))]), _vm._v("个仓库")]) : _c('div', [_vm._v("全部仓库")]), _vm._v(" "), (_vm.session.zhanghao.guanxiacangkus) ? _c('CustomData', {
    attrs: {
      "current": _vm.session.zhanghao.guanxiacangkus || [],
      "unimode": "",
      "moveable": false,
      "query": {},
      "fields": {
        _id: 1,
        name: 1,
        code: 1,
        'jigou._id': 1,
        'jigou.name': 1,
        'jigou.type': 1,
        'jiagongjian._id': 1,
        'jiagongjian.name': 1,
      },
      "multi": true,
      "editable": false,
      "datatype": "cangku"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background-color": "#fafafa",
      "min-width": "200px",
      "border-radius": "4px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("管辖供应商")]), _vm._v(" "), (_vm.session.zhanghao['guanxiagonghuojigoumode'] == 'part') ? _c('div', [_c('span', {
    staticStyle: {
      "color": "#20bf64",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.session.zhanghao.guanxiagonghuojigous.length))]), _vm._v("个供应商")]) : _c('div', [_vm._v("全部供应商")]), _vm._v(" "), (_vm.session.zhanghao.guanxiagonghuojigous) ? _c('CustomData', {
    attrs: {
      "current": _vm.session.zhanghao.guanxiagonghuojigous || [],
      "unimode": "",
      "moveable": false,
      "fields": {
        _id: 1,
        name: 1,
        code: 1
      },
      "multi": true,
      "query": {
        type: 'KS',
        mendian: null
      },
      "editable": false,
      "datatype": "jigou"
    }
  }) : _vm._e()], 1)])]) : _vm._e()], 2), _vm._v(" "), _c('Modal', {
    staticClass: "nopadding",
    attrs: {
      "footer-hide": "",
      "closable": true,
      "width": 280
    },
    model: {
      value: (_vm.qrcodeModal),
      callback: function($$v) {
        _vm.qrcodeModal = $$v
      },
      expression: "qrcodeModal"
    }
  }, [_c('div', {
    staticClass: "center",
    staticStyle: {
      "padding": "20px 40px"
    }
  }, [(!_vm.bind && !_vm.binderror) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.qrcode) ? _c('img', {
    staticStyle: {
      "width": "240px",
      "height": "240px",
      "border-radius": "16rpx"
    },
    attrs: {
      "src": _vm.qrcode.url
    }
  }) : _c('div', {
    staticStyle: {
      "color": "#aaa",
      "height": "240px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_vm._v("二维码加载中")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v(_vm._s(_vm.session.user.phone))]), _vm._v(" "), (_vm.qrcodetype == 'bind') ? _c('div', [_vm._v("微信扫码绑定该账号")]) : _vm._e(), _vm._v(" "), (_vm.qrcodetype == 'unbind') ? _c('div', [_vm._v("请使用绑定该账号的微信扫码解绑")]) : _vm._e()])]) : (_vm.binderror) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "red",
      "font-size": "80px"
    },
    attrs: {
      "type": "ios-close-circle"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("绑定失败")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.binderror))])], 1) : (_vm.bind) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#20bf64",
      "font-size": "80px"
    },
    attrs: {
      "type": "ios-checkmark-circle"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.qrcodetype == 'bind') ? _c('div', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("绑定成功")]) : _vm._e(), _vm._v(" "), (_vm.qrcodetype == 'unbind') ? _c('div', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("解除绑定成功")]) : _vm._e(), _vm._v(" "), (_vm.qrcodetype == 'bind') ? _c('div', [_vm._v("已可使用微信扫码登陆系统")]) : _vm._e(), _vm._v(" "), (_vm.qrcodetype == 'unbind') ? _c('div', [_vm._v("已可使用新的微信绑定该账号")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  })])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "0 20px"
    }
  }, [_c('div', [_vm._v("个人中心")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-295d47fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ProfileForm.vue
// module id = zJnJ
// module chunks = 142